import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import React from 'react'

import { useStyles } from './styles'

interface BlockedServiceAlertProps {
  loading?: boolean
  title?: string
  message?: string
  backgroundColor?: string
}

export default function BlockedServiceAlert({
  loading = false,
  title = 'Serviço Indisponível',
  message,
  backgroundColor = '#fff',
}: BlockedServiceAlertProps): JSX.Element {
  const classes = useStyles()

  return (
    <Box className={classes.container} style={{ backgroundColor }}>
      {loading ? (
        <CircularProgress size={40} />
      ) : (
        <>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.message}>{message}</Typography>
        </>
      )}
    </Box>
  )
}
